var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('span',[_vm._v(" Внимание! Является информационным документом, не применим для расчета по налогу на добавленную стоимость! ")]),_c('x-tabs',{attrs:{"titles":_vm.titles,"components":_vm.components}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }